import { useEffect, useState } from 'react';

interface AuditProgressProps {
  accountName: string;
  totalSections: number;
  startMs: number | null;
  currentActivity?: string | null;
}

const formatElapsed = (ms: number): string => {
  const seconds = Math.floor(ms / 1000);
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${minutes}m ${remainingSeconds}s`;
};

// The single agent call behind a run reports its own lifecycle (run started, tool calls,
// finish — see auditAgentClient.ts's onActivity) into current_activity, which the 2s poll of
// getAuditRun picks up — so this can show live status rather than only elapsed time.
export const AuditProgress = ({
  accountName,
  totalSections,
  startMs,
  currentActivity
}: AuditProgressProps) => {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const interval = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(interval);
  }, []);

  const elapsedMs = startMs ? now - startMs : 0;

  return (
    <div className='google-ads-audit-progress'>
      <div className='google-ads-audit-progress-status'>
        Running {totalSections} section checks for {accountName}…
      </div>
      {startMs !== null && (
        <div className='google-ads-audit-progress-timing'>Elapsed {formatElapsed(elapsedMs)}</div>
      )}
      <div className='google-ads-audit-progress-activity'>{currentActivity ?? 'Connecting…'}</div>
      <div className='google-ads-audit-progress-timing'>
        This can take several minutes — feel free to switch tabs, it&apos;ll keep running.
      </div>
    </div>
  );
};
